// client/src/features/quotations/repriceConfirm.ts
//
// D101.2: "Cost moved X -> Y, Apply" asks first, because Apply moves the Master Catalogue price
// every future quotation is priced from. This builds the confirm's wording from the same
// figures the banner prints. `fromPrice` is null for reasons 'currency' and 'no_baseline' and
// is then left out, never printed as "null" / "NaN".
import type { PendingReprice } from '../../lib/quotationApi';

const money = (currency: string | undefined, n: number) => `${currency ? `${currency} ` : ''}${n.toFixed(2)}`;

export function repriceApplyConfirm(itemName: string, p?: Pick<PendingReprice, 'fromPrice' | 'toPrice' | 'currency'> | null) {
  const to = typeof p?.toPrice === 'number' && Number.isFinite(p.toPrice) ? money(p.currency, p.toPrice) : null;
  const from = typeof p?.fromPrice === 'number' && Number.isFinite(p.fromPrice) ? money(p.currency, p.fromPrice) : null;
  const moved =
    from && to ? `Its cost will move from ${from} to ${to}.` : to ? `Its cost will be set to ${to}.` : 'Its cost will be updated.';
  return {
    title: `Apply the new price to "${itemName}"?`,
    summary: `${moved} This changes the Master Catalogue price that future quotations are priced from.`,
    confirmLabel: 'Apply',
  };
}
